__turbopack_context__.v({
  "modal": "_6O-KHa_modal",
  "modal--large": "_6O-KHa_modal--large",
  "modal--medium": "_6O-KHa_modal--medium",
  "modal--small": "_6O-KHa_modal--small",
  "modal--xlarge": "_6O-KHa_modal--xlarge",
  "modal__actions": "_6O-KHa_modal__actions",
  "modal__body": "_6O-KHa_modal__body",
  "modal__close": "_6O-KHa_modal__close",
  "modal__content": "_6O-KHa_modal__content",
  "modal__description": "_6O-KHa_modal__description",
  "modal__icon": "_6O-KHa_modal__icon",
  "modal__title": "_6O-KHa_modal__title",
  "overlay": "_6O-KHa_overlay",
  "overlay--top": "_6O-KHa_overlay--top",
  "scaleIn": "_6O-KHa_scaleIn",
  "shimmer": "_6O-KHa_shimmer",
  "text-bar-sweep": "_6O-KHa_text-bar-sweep",
  "visible": "_6O-KHa_visible",
});
